import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { IpService } from '../../../shared/servicio/ip/ip.service';
import { MedicoService } from '../../../shared/servicio/medico/medico.service';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';
import { environment } from 'src/environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ComercialService } from 'src/app/shared/servicio/comercial/comercial.service';
import { formatDate } from 'ngx-bootstrap';

// variable para usaer jquery en los componentes
declare var $: any;

@Component({
  selector: 'app-home-comercial',
  templateUrl: './home-comercial.component.html',
  styleUrls: ['./home-comercial.component.css'],
})
export class HomeComercialComponent implements OnInit {
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered modal-app modal-app-sm',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  config2 = {
    animated: true,
    class: 'modal-dialog-centered modal-app modal-app-sm',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  //contenedor del componente HTML
  dataLista = false;

  // campo de formulario para mostrar lista de medicos en las actualizacion de
  // datos
  searchLab: FormControl;

  // campo de formulario para mostrar lista de medicos en la creación de usuarios
  create_especialidad_input: FormControl;

  // array de los datos de backend muestra informacion sobre medicos
  medicos_array: any;

  // array de los datos de backend muestra informacion sobre las especialidades de
  // un medico en particular
  especialidades: any;

  // array de los datos de la busqueda en los select de busqueda de formulario
  especialidades_search: any;

  // dato para paginacion de resultados
  page: number;
  p: number;
  totalpages: number;
  itemsPagina: any;

  // variable para las busquedas del formulario principal
  criterio: string = 'none';
  searchtext: string = '';
  searchtext2: string = 'none';
  orden: string = 'none';
  activate: number = 0;
  selectradio: any = 0;

  // estados por base de datos
  api_estados: any;

  // inputs para crear y actualizar usuarios
  modal_ver_nombre_completo: string = '';
  modal_ver_nombre: string = '';
  modal_ver_nombre2: string = '';
  modal_ver_apellido: string = '';
  modal_ver_apellido2: string = '';
  modal_ver_telefono: string = '';
  modal_ver_email: string = '';
  modal_ver_tipo: string = '';
  modal_ver_user: string = '';
  modal_ver_puntos: number;
  modal_ver_matricula: string = '';
  modal_ver_estado: boolean;
  modal_ver_codigo: string = '';
  modal_ver_nombre_referido: string = '';

  //orden ascendente y descendente de la lista
  order: number = 0;
  direction: number = 0;

  //estado de debugs
  debug: boolean;
  //id de medico
  id_medic: number = 0;

  //estado de medico
  estado: boolean;

  //select estados
  estado2: string = 'none';
  text_estado: number;

  // array de datos de especialidades de los medicos para actualizacion
  especialidades_array: Array<any> = [];

  // array de datos de especialidades de los medicos para creacion
  especialidades_array_create: Array<any> = [];

  // array de datos de especialidades de los medicos para eliminacion
  especialidades_array_delete: Array<any> = [];

  // Identificador del medico
  id: number;

  // preloaders de carga
  preloader: boolean = false;
  div_error: number = 0;
  div_text_error: string = '';

  /**
   * Input de fecha inicial (fecha de activación de cuenta)
   */
  startDateFC: FormControl;

  /**
   * Input de fecha de finalización (fecha de activación de cuenta)
   */
  endDateFC: FormControl;

  laboratoriesList: any[] = []; // array para llenar el select
  selectedLaboratoryId: number | null = null; // lo que el usuario selecciona
  medicId: number; // o el ID que manejes dinámicamente
  assignedLaboratories: any[] = []; // para la tabla


  /**
   * Input de búsqueda
   */
  searchTextFC: FormControl;

  /**
   * Selector de estados del médico
   */
  statusSelectorFC: FormControl;

  /**
   * Selector de filtros (nombre, apellido, etc)
   */
  criterioSelectorFC: FormControl;

  /**
   * Filtro de médicos con cuenta habilitada
   */
  isEnabledFilterON;

  /**
   * Filtro de médicos con cuenta deshabilitada
   */
  isDisabledFilterON;

  /**
   * Filtro de email verificado
   */
  isMailVerifiedFilterON;

  /**
   * Filtro de email no verificado
   */
  isMailNotVerifiedFilterON;

  constructor(
    public _medic: MedicoService,
    private _comercial: ComercialService,
    public _ip: IpService,
    private _http: HttpClient,
    public router: Router,
    public _helper: HelpersService,
    private modalService: BsModalService
  ) {
    //campos de formularios para los campos select
    this.searchLab = new FormControl('', Validators.required);
    this.create_especialidad_input = new FormControl(null, Validators.required);
  }

  ngOnInit() {
    this.startDateFC = new FormControl('');
    this.endDateFC = new FormControl('');
    this.criterioSelectorFC = new FormControl('none');
    this.statusSelectorFC = new FormControl(0);
    this.searchTextFC = new FormControl('');
    this.isEnabledFilterON = false;
    this.isDisabledFilterON = false;
    this.isMailVerifiedFilterON = false;
    this.isMailNotVerifiedFilterON = false;
    this.medicos_array = [];
    this.list_medic(this.p);
    this.debug_db();
    this.estados();
    this.searchTextFC.valueChanges.subscribe((value) => {
      this.search_medic(value);
    });
    this.statusSelectorFC.valueChanges.subscribe((onChange) => {
      this.list_medic(this.p);
    });
    this.criterioSelectorFC.valueChanges.subscribe((onChange) => {
      this.list_medic(this.p);
    });
    this.startDateFC.valueChanges.subscribe((onchange) => {
      this.list_medic(this.p);
    });
    this.endDateFC.valueChanges.subscribe((onChange) => {
      this.list_medic(this.p);
    });
  }

  getAllLaboratories() {
    this._comercial.getLabs().subscribe({
      next: (response: any) => {
        this.laboratoriesList = response;
      },
      error: (err) => {
        this._helper.modalError('¡Error al cargar los laboratorios!');
      },
    });
  }

  resetMedicCredentialsSMS(medicID) {
    // Mostrar confirmación antes de proceder
    this._helper.modalConfirm(
      '¿Estás seguro de que deseas restablecer las credenciales por SMS al médico?'
    ).then((confirmed) => {
      if (confirmed) {
        this.preloader = true;

        this._comercial.resend_credentials_sms(medicID).subscribe(
          (onSuccess) => {
            this.preloader = false;
            this._helper.modalSuccess(
              '¡Las credenciales se han enviado por SMS al médico!'
            );
          },
          (error) => {
            this.preloader = false; // Asegurarse de ocultar el preloader en caso de error
            this._helper.modalError('¡Error intentando enviar credenciales por SMS!');
          }
        );
      }
    });
  }

  associateLaboratory() {
    if (!this.selectedLaboratoryId || !this.medicId) {
      this._helper.modalError('Selecciona un laboratorio y asegúrate de tener un médico activo.');
      return;
    }

    this._comercial.postLabsMedics(this.medicId, this.selectedLaboratoryId).subscribe({
      next: (res) => {
        this._helper.modalSuccess('¡Laboratorio asociado correctamente!');
        this.modalRef.hide();
      },
      error: (err) => {
        this._helper.modalError('Error al asociar el laboratorio.');
      },
    });
  }

  removeLaboratory(laboratoryId: number) {
    if (!this.medicId) {
      this._helper.modalError('Médico no válido.');
      return;
    }

    this._comercial.deleteLaboratoryFromMedic(this.medicId, laboratoryId).subscribe({
      next: () => {
        this._helper.modalSuccess('¡Laboratorio eliminado correctamente!');
        this.getAssignedLaboratories(); // recargar lista después de eliminar
      },
      error: () => {
        this._helper.modalError('Error al eliminar laboratorio.');
      },
    });
  }



  getAssignedLaboratories() {
    if (!this.medicId) return;

    this._comercial.getLaboratoriesByMedic(this.medicId).subscribe({
      next: (labs: any[]) => {
        this.assignedLaboratories = labs;
      },
      error: () => {
        this._helper.modalError('Error al obtener laboratorios asignados.');
      }
    });
  }



  /**
   * Valida los valores de los input de fecha de inicio y fin para el filtro de lista
   */
  validateDate() {
    var startDate, endDate;
    if (this.startDateFC.value == undefined || this.startDateFC.value == '') {
      startDate = 'none';
    } else {
      startDate = this.getFormatedDate(this.startDateFC.value);
    }

    if (this.endDateFC.value == undefined || this.endDateFC.value == '') {
      endDate = 'none';
    } else {
      endDate = this.getFormatedDate(this.endDateFC.value);
    }
    return [startDate, endDate];
  }

  /**
   * Función que intercepta el evento de elección de fecha del NGX DatePicker
   * @param calendarView Instancia de calendario que disparó el evento
   * @param isStart Booleano que indica si al instancia originaria fue la fecha de inicio o la de fin
   */
  opencalendar(calendarView, isStart) {
    if (isStart) {
      this.startDateFC.setValue('');
    } else {
      this.endDateFC.setValue('');
    }
    calendarView.yearSelectHandler = (event: any): void => {
      calendarView._store.dispatch(calendarView._actions.select(event.date));
    };
    calendarView.setViewMode('day');
  }

  /**
   * Función que toma una fecha completa y en Y-M-D:H-M-S y la transforma a Y-M-D
   * @param joinDate Fecha
   */
  getFormatedDate(joinDate) {
    return formatDate(joinDate, 'YYYY-MM-DD', 'es');
  }

  getMedicState(state) {
    switch (state) {
      case 1:
        return 'Registrado';
      case 2:
        return 'Incomunicado';
      case 3:
        return 'Pendiente';
      case 4:
        return 'No interesado';
      case 5:
        return 'Inactivo';
      case 6:
        return 'Activo';
    }
  }

  // Contiene la lista de todos los medicos paginados.
  list_medic(p2) {
    var [startDate, endDate] = this.validateDate();

    console.log(startDate);
    console.log(endDate);

    if (p2 === undefined) {
      p2 = 1;
    } else {
      p2 - 1;
    }

    this.vista_console(p2, 'Valor de pagina');

    if (this.searchtext2 === '') {
      this.searchtext2 = 'none';
    }

    this.vista_console(this.searchtext2, 'Valor de busqueda');

    this._http
      .get(
        environment.Api_get_medic +
        0 +
        '/' +
        this.searchtext2 +
        '/' +
        this.statusSelectorFC.value +
        '/' +
        this.order +
        '/' +
        this.direction +
        '/' +
        startDate +
        '/' +
        endDate +
        '/' +
        p2
      )
      .subscribe(
        (data) => {
          console.log('Lista de médicos');
          console.log(data);
          this.medicos_array = data['info'];
          this.totalpages = data['page_info']['count'];
          this.itemsPagina = data['page_info']['total_items'];
          this.p = data['page_info']['current'];
        },
        (error) => {
          this.manejador_errores(error);
        }
      );
  }

  // metodo para cambiar la pagina dinamicamente recibe un argumento que es el
  // numero de la pagina
  getPage(p) {
    var [startDate, endDate] = this.validateDate();
    this._http
      .get(
        environment.Api_get_medic +
        this.criterioSelectorFC.value +
        '/' +
        this.searchtext2 +
        '/' +
        this.statusSelectorFC.value +
        '/' +
        this.order +
        '/' +
        this.direction +
        '/' +
        startDate +
        '/' +
        endDate +
        '/' +
        p
      )
      .subscribe(
        (data) => {
          this.vista_console(data, 'paginacion');
          this.list_medic(p);
        },
        (error) => {
          this.manejador_errores(error);
        }
      );
  }

  estados() {
    this._medic.list_estados().subscribe(
      (data) => {
        this.api_estados = data;
        console.log(this.api_estados);
      },
      (error) => {
        console.log('Ocurrió un error!');
        console.log(error);
      }
    );
  }

  // metodo para las busquedas recibe un argumento tipo formulario donde pasamos
  // los campos de busqueda a la api
  search_medic(name) {
    if (name == undefined || name == '') {
      this.searchtext2 = 'none';
    }
    this.vista_console(name, 'Buscar en la lista de medicos');
    this.searchtext2 = name;
    this.list_medic(this.p);
  }

  // metodo que recibe el identificador de un medico para mostrar la informacion
  // del usuario
  medico_id(id: number) {
    this._medic.medic_id(id).subscribe(
      (data) => {
        this.vista_console(data, 'Busqueda individual medico');
        this.modal_ver_nombre_completo =
          data['user_info']['first_name'] +
          ' ' +
          data['user_info']['first_name2'] +
          ' ' +
          data['user_info']['last_name'];
        this.modal_ver_nombre = data['user_info']['first_name'];
        this.modal_ver_nombre2 = data['user_info']['first_name2'];
        this.modal_ver_apellido = data['user_info']['last_name'];
        this.modal_ver_apellido2 = data['user_info']['last_name2'];
        this.modal_ver_telefono = data['user_info']['cell'];
        this.modal_ver_email = data['user_info']['email'];
        this.modal_ver_tipo = data['user_info']['role'];
        this.modal_ver_user = data['user_info']['dni'];
        this.modal_ver_puntos = data['medic_info']['points'];
        this.modal_ver_matricula = data['medic_info']['profesional_license'];
        this.modal_ver_codigo = data['medic_info']['referral_code'];
        this.modal_ver_estado = data['medic_info']['validated'];
        this.id_medic = data['medic_info']['id'];
        this.especialidades_array = [];
        this.especialidades_array_delete = [];
        this.especialidades = data['specialties'];
        this.estado2 = data['medic_info']['state'];

        if (
          data['medic_info']['state'] === 5 ||
          data['medic_info']['state'] === 6
        ) {
          this.text_estado = 1;
        } else {
          this.text_estado = 0;
        }

        if (data['referral_info'].length === 0) {
          this.modal_ver_nombre_referido = 'No aplica';
        } else {
          this.modal_ver_nombre_referido =
            data['referral_info'][0]['medic_patreon__user_id__first_name'] +
            ' ' +
            data['referral_info'][0]['medic_patreon__user_id__last_name'];
        }
        $('#ver_medico').modal('show');
      },
      (error) => {
        this.manejador_errores(error);
      }
    );
  }

  // Metodo de actualizacion se envian los datos de formulario a la api para
  // actualizacion del medico
  actualizar_medico(update: NgForm) {
    this.vista_console(update.value, 'Datos del formulario de actualizacion');
    if (this.validators() != '') {
      this._helper.modalError(this.validators());
    } else {
      this._medic
        .update_medic(
          this.id_medic,
          update.value['modal_ver_nombre'],
          update.value['modal_ver_nombre2'],
          update.value['modal_ver_apellido'],
          update.value['modal_ver_apellido2'],
          update.value['modal_ver_email'],
          update.value['modal_ver_matricula'],
          update.value['modal_ver_telefono'],
          update.value['modal_ver_user'],
          this.estado2,
          this.especialidades_array,
          this.especialidades_array_delete
        )
        .subscribe(
          (data) => {
            this.vista_console(data, 'Medico actualizado');
            $('#ver_medico').modal('hide');
            this.list_medic(this.p);
          },
          (error) => {
            this.manejador_errores(error);
          }
        );
    }
  }

  // Validacion de datos para las actualizaciones y creaciones de medicos
  validators() {
    var create_medic = [];
    create_medic.push(
      {
        tipo: 'text',
        nombre: 'NOMBRE',
        valor: this.modal_ver_nombre,
        requerido: 'si',
        min_length: 2,
      },
      {
        tipo: 'text',
        nombre: 'APELLIDO',
        valor: this.modal_ver_apellido,
        requerido: 'si',
        min_length: 2,
      },
      {
        tipo: 'text',
        nombre: 'APELLIDO 2',
        valor: this.modal_ver_apellido2,
        requerido: 'no',
        min_length: 2,
      },
      {
        tipo: 'phone',
        nombre: 'CELULAR',
        valor: this.modal_ver_telefono,
        requerido: 'si',
        min_length: 10,
      },
      {
        tipo: 'email',
        nombre: 'CORREO',
        valor: this.modal_ver_email,
        requerido: 'si',
        min_length: 6,
      },
      {
        tipo: 'number',
        nombre: 'DNI',
        valor: this.modal_ver_user,
        requerido: 'si',
        min_length: 5,
      },
      {
        tipo: 'alpha',
        nombre: 'LICENCIA',
        valor: this.modal_ver_matricula,
        requerido: 'si',
        min_length: 5,
      },
      {
        tipo: 'select',
        nombre: 'ESTADO',
        valor: this.estado2,
        requerido: 'si',
        min_length: 1,
      }
    );
    return this._helper.validators(create_medic);
  }

  //metodo que recibe los campos de formulario para agregar medico
  agregar_medico(save: NgForm) {
    this.preloader = true;
    this._medic
      .create_medic(
        save.value['modal_ver_nombre'],
        save.value['modal_ver_nombre2'],
        save.value['modal_ver_apellido'],
        save.value['modal_ver_apellido2'],
        save.value['modal_ver_email'],
        save.value['modal_ver_matricula'],
        save.value['modal_ver_telefono'],
        save.value['modal_ver_user'],
        save.value['estado2'],
        this.especialidades_array_create
      )
      .subscribe(
        (data) => {
          $('#agregar_medico').modal('hide');
          this.list_medic(this.p);
          this.especialidades_array_create = [];
          this.preloader = false;
          this.div_error = 0;
          this.div_text_error = '';
        },
        (error) => {
          this.preloader = false;
          this.div_error = 1;
          this.div_text_error = this._helper.error('', error);
        }
      );
  }

  //metodo que recibe el select2 de angular para hacer la peticion asincrona
  updateEspecialidad(event) {
    this._medic.list_especialidad(event).subscribe(
      (data) => {
        this.especialidades_search = data;
        this.vista_console(data, 'Buscador del select');
      },
      (error) => {
        this.manejador_errores(error);
      }
    );
  }

  //metodo para agregar las especialidades al array
  especialidad_form() {
    if (this.searchLab.value === null) {
      this._helper.modalAlert('¡No se ha escogido alguna especialidad!');
    } else if (
      this.validar_especialidad(
        this.searchLab.value['id'],
        this.especialidades_array
      ) === true
    ) {
      this._helper.modalAlert(
        '¡La especialidad ya se encuentra en el detalle!'
      );
    } else if (
      this.searchLab.value['id'] === undefined ||
      this.searchLab.value['id'] === null
    ) {
      this._helper.modalAlert('¡No se ha escogido alguna especialidad!');
    } else if (
      this.validar_medico_especialidad(this.searchLab.value['name']) === true
    ) {
      this._helper.modalAlert('¡Ya se agregó esta especialidad al médico!');
    } else {
      this.especialidades_array.push({
        id: this.searchLab.value['id'],
        nombre: this.searchLab.value['name'],
      });
    }
  }

  // meotodo que evalua que dentro del array de especialidades  no se encuentren
  // item repetidos
  validar_especialidad(id: number, array: any) {
    var sw = false;
    for (var _i = 0; _i < array.length; _i++) {
      if (array[_i]['id'] === id) {
        sw = true;
      }
    }
    return sw;
  }

  //metodo que evalua las especialidad dentro de la creacion de usuarios
  validar_medico_especialidad(id: string) {
    var sw = false;
    for (var _i = 0; _i < this.especialidades.length; _i++) {
      if (this.especialidades[_i]['specialty_id__name'] === id) {
        sw = true;
      }
    }
    return sw;
  }

  // metodo que evalua las especialidades que se van a eliminar en las
  // actualializaciones
  validar_array_eliminado(id: number) {
    var sw = false;
    for (var _i = 0; _i < this.especialidades_array_delete.length; _i++) {
      if (this.especialidades_array_delete[_i]['id'] === id) {
        sw = true;
      }
    }
    return sw;
  }

  getDoctorStateString(state) {
    switch (state) {
      case 1:
        return 'Registrado';
      case 2:
        return 'Incomunicado';
      case 3:
        return 'Pendiente';
      case 4:
        return 'No Interesado';
      case 5:
        return 'Inactivo';
      case 6:
        return 'Activo';
      default:
        return 'Desconocido';
    }
  }

  //metodo que elimina un elemento dentro de un array de especialidades
  eliminar_especialidad(number: number, array: any) {
    array.splice(number, 1);
  }

  //metodo que elimina o agrega un elemento dentro de un array de especialidades
  eliminar_especialidad_actual(number: any, id: number) {
    var boton = '#name_' + number;
    if ($(boton).hasClass('btn update_especialidades')) {
      $(boton).removeClass('btn update_especialidades');
      $(boton).addClass('btn delete_especialidades');
      if (this.validar_array_eliminado(id) === false) {
        this.especialidades_array_delete.push({ id: id });
      }
    } else {
      $(boton).removeClass('btn delete_especialidades');
      $(boton).addClass('btn update_especialidades');
      this.especialidades_array_delete.splice(number - 1, 1);
    }
  }

  //metodo para crear un item dentro del del array de especialidades
  create_especialidad() {
    if (this.create_especialidad_input.value === null) {
      this._helper.modalAlert('¡No se ha escogido alguna especialidad!');
    } else if (
      this.validar_especialidad(
        this.create_especialidad_input.value['id'],
        this.especialidades_array_create
      ) === true
    ) {
      this._helper.modalAlert(
        '¡La especialidad ya se encuentra en el detalle!'
      );
    } else if (
      this.create_especialidad_input.value['id'] === undefined ||
      this.create_especialidad_input.value['id'] === null
    ) {
      this._helper.modalAlert('¡No se ha escogido alguna especialidad!');
    } else {
      this.especialidades_array_create.push({
        id: this.create_especialidad_input.value['id'],
        name: this.create_especialidad_input.value['name'],
      });
    }
  }

  // Metodo para  controlar las exepciones cuando falla las conexiones con el
  // servidor
  manejador_errores(error) {
    if (this.debug === true) {
      console.log(error);
    } else {
      console.log('Debug no habilitado');
    }
    if (error.status === 400) {
      this._helper.modalError('¡' + error.error + '!');
    } else if (error.statusText === 'Unknown Error') {
      this._helper.modalError('¡Error de conexión con el servidor!');
    } else if (error.status === 500) {
      this._helper.modalError('¡Error en el servidor!');
    } else if (error.status === 403) {
      this._helper.modalError('¡Página no encontrada!');
      this.router.navigate(['/login']);
    }
  }

  // Metodo para mostrar el debug de los console.log en el navegador
  vista_console(data, string: string) {
    if (this.debug === true) {
      console.log(string, data);
    } else {
      console.log('Debug no habilitado');
    }
  }

  // Conexion para ver el estado del debug
  debug_db() {
    this._ip.debug().subscribe(
      (data) => {
        this.debug = data['state'];
        this.vista_console(data, 'valor del debug');
      },
      (error) => {
        this.manejador_errores(error);
      }
    );
  }

  ordenamiento(valor: number, orden: number) {
    this.order = valor;
    this.direction = orden;
    this.list_medic(this.p);
  }

  limpiar_modal() {
    this.modal_ver_nombre = '';
    this.modal_ver_apellido = '';
    this.modal_ver_nombre2 = '';
    this.modal_ver_apellido2 = '';
    this.modal_ver_telefono = '';
    this.modal_ver_email = '';
    this.modal_ver_user = '';
    this.modal_ver_matricula = '';
    this.estado = false;
    this.estado2 = 'none';
    this.vista_console('', 'DATOS DEL FORMULARIO LIMPIOS!!');
  }

  //Actualizar lista
  actualizar_lista(event) {
    console.log(event);
    if (event === '1') {
      this.list_medic(this.p);
    }
  }

  //FABY UPDATE MEDIC COMERCIAL

  updateMedic(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  openespecialidad(template: TemplateRef<any>, id: number) {
    this.medicId = id;
    this.getAllLaboratories(); // cargar laboratorios al abrir modal
    this.getAssignedLaboratories();
    this.modalRef = this.modalService.show(template, this.config);
  }

  createMedic(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, this.config2);
  }

  actualizarLista($event) {
    if ($event === true) {
      this.modalRef.hide();
      this.list_medic(this.p);
    }
  }

  actualizarListaC($event) {
    if ($event === true) {
      this.modalRef2.hide();
      this.list_medic(this.p);
    }
  }

  /**
   * Función para reiniciar la contraseña de un médico
   * @param medicID Id del médico a reestablecer las credenciales
   */
  resetMedicCredentials(medicID) {
    this._comercial.resend_credentials(medicID).subscribe(
      (onSuccess) => {
        this._helper.modalSuccess(
          '¡La nueva contraseña se ha enviado al correo del médico!'
        );
      },
      (error) => {
        this._helper.modalError('¡Error intentando resetear credenciales!');
      }
    );
  }
}
